// Copyright (c) 2021 Deere & Company

import MassLaborRateRequestStatus from './components';
import actionCreators from './action-creators';
import {connect} from 'react-redux';
import {getLaborRateRequestStatus} from './services/labor-rate-request-status-helper';

const requeststatusOptions = [
    {key: '01', value: 'SUBMITTED'},
    {key: '02', value: 'APPROVED'},
    {key: '03', value: 'REJECTED'},
    {key: '04', value: 'RETURNED'}
];

const getStateToBindToContainerProps = state => ({
    ...state.claims.laborRateDealers.laborRateRequestDetails,
    requestStatus: getLaborRateRequestStatus(requeststatusOptions)
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;
    const queryParams = parentProps.location.query;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        queryParams,
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(MassLaborRateRequestStatus);




// WEBPACK FOOTER //
// ./src/claim/mass-labor-rate-request-status-details/state-connector.js